<div class="modal-header">
  <div class="modal-title pull-left">
    <h1 class="h2" [ngClass]="{'mb-0' : content && content.length}">
      {{ 'MODALS.CONFIRM.' + headingKey | translate }}
    </h1>
  </div>
  <button *ngIf="!hideCloseIcon" type="button" class="close pull-right" aria-label="Close" (click)="onClickCancel()">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body" *ngIf="content && content.length">
  <div class="modal-bodyWrap">
    <ng-container *ngFor="let row of content">
      <div class="modal-bodySection modal-bodySection_{{row.type}}" [ngStyle]="row.maxHeight && {'maxHeight': row.maxHeight, 'overflowX': 'auto' }" *ngIf="row.value">
        <ng-container [ngSwitch]="row.type">
          <ng-container *ngSwitchCase="'title'">
            <h2 class="h5 modal-body-title" [innerHTML]="row.value"></h2>
          </ng-container>
          <ng-container *ngSwitchCase="'text'">
            <div [innerHTML]="row.value"></div>
          </ng-container>
          <ng-container *ngSwitchCase="'list'">
            <ul *ngIf="row.value && row.value.length">
              <li *ngFor="let val of row.value" [innerHTML]="val"></li>
            </ul>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<div class="modal-footer">
  <div
    class="modal-action d-flex align-items-center flex-column flex-sm-row"
    [ngClass]="{ 'justify-content-between': showCancel && showConfirm, 'justify-content-center': showCancel !== showConfirm }"
  >
    <div *ngIf="showCancel" [ngClass]="{ 'ml-0': showCancel !== showConfirm }">
      <button type="button" class="btn btn_sm btn_ghost" (click)="onClickCancel()">
        {{ cancel | translate }}
      </button>
    </div>
    <div *ngIf="showConfirm" [ngClass]="{ 'ml-0': showCancel !== showConfirm }">
      <button type="button" class="btn btn_sm btn_primary" (click)="onClickConfirm()">
        {{ confirm | translate }}
      </button>
    </div>
  </div>
</div>
